export const productCopy: Record<string, string> = {
  // ---- Common ----
  'common.login': '登录',
  'common.signup': '注册',
  'common.signout': '退出登录',
  'common.loading': '加载中...',
  'common.save': '保存',
  'common.cancel': '取消',
  'common.confirm': '确认',
  'common.back': '返回',
  'common.viewAll': '查看全部',
  'common.comingSoon': '即将上线',
  'common.loadMore': '加载更多',
  'common.copyFailed': '复制失败，请手动复制',

  // ---- Nav ----
  'nav.home': '首页',
  'nav.discover': '发现',
  'nav.write': '写信',
  'nav.letters': '信箱',
  'nav.me': '我的',
  'nav.drift': '漂流',
  'nav.courier': '信使',
  'nav.museum': '博物馆',
  'nav.plaza': '广场',
  'nav.profile': '我的',
  'nav.settings': '设置',
  'nav.about': '关于 OpenPenPal',

  // ---- Home ----
  'home.badge': '重新定义校园社交',
  'home.title1': '一封手写信，',
  'home.title2': '慢下来连结世界',
  'home.subtitle': '在快节奏的数字时代，让我们重新拾起笔墨，用最真挚的文字传递温暖，用最慢的方式建立最深的连接。',
  'home.cta.write': '写信去',
  'home.cta.courier': '加入信使',

  'home.features.title': '四种方式，连接心灵',
  'home.features.subtitle': '每一种体验都是一次心灵的旅程',
  'home.features.write.title': '写一封信给过去或未来',
  'home.features.write.desc': '用墨水记录此刻的心情，寄给未来的自己或陌生的朋友',
  'home.features.write.btn': '立即写信',
  'home.features.inbox.title': '打开别人的来信',
  'home.features.inbox.desc': '每一封信都是一个故事，每一个故事都值得被倾听',
  'home.features.inbox.btn': '去查收',
  'home.features.courier.title': '成为投递的连接者',
  'home.features.courier.desc': '加入信使队伍，成为连接心灵的桥梁',
  'home.features.courier.btn': '加入信使',
  'home.features.plaza.title': '与文字爱好者共创',
  'home.features.plaza.desc': '在写作广场分享你的文字，发现更多有趣的灵魂',
  'home.features.plaza.btn': '浏览作品',

  'home.stories.title': '来自各地的温暖故事',
  'home.stories.subtitle': '每一个故事都见证着真实连接的力量',
  'home.stories.1.content': '收到一封来自陌生人的信，里面写着"你并不孤单"，那一刻眼泪就掉下来了。',
  'home.stories.1.author': '来自北京的小雨',
  'home.stories.1.location': '北京大学',
  'home.stories.2.content': '给三年后的自己写了一封信，希望到时候能成为更好的人。',
  'home.stories.2.author': '来自上海的阿明',
  'home.stories.2.location': '复旦大学',
  'home.stories.3.content': '当信使三个月了，每次看到收信人开心的表情，都觉得很有意义。',
  'home.stories.3.author': '来自广州的小李',
  'home.stories.3.location': '中山大学',

  'home.values.slow': '慢节奏',
  'home.values.slow.desc': '告别即时反馈的焦虑，重拾等待的美好',
  'home.values.real': '真实感',
  'home.values.real.desc': '手写的温度，墨水的香气，最真挚的表达',
  'home.values.deep': '深连接',
  'home.values.deep.desc': '跨越时空的心灵对话，建立持久的情感纽带',

  'home.museum.title': '信件博物馆',
  'home.museum.subtitle': '那些被时光记录的美好文字',
  'home.museum.viewMore': '查看更多信件',

  'home.cta2.title': '准备好开始你的书信之旅了吗？',
  'home.cta2.subtitle': '加入数千名校园笔友，重新发现手写交流的美好',
  'home.cta2.btn': '写下你的第一封信',
  'home.cta2.btnLogin': '免费开始',

  'home.footer.switchLitopia': '切换到 Litopia',

  // ---- Feed Home ----
  'feed.banner.title': '写一封信，\n遇见一个故事',
  'feed.banner.subtitle': '每封信都是一段旅程',
  'feed.banner.btn': '开始写信',
  'feed.writeCard.title': '写一封信',
  'feed.writeCard.desc': '用文字记录此刻的心情',
  'feed.writeCard.btn': '写信去',
  'feed.hotLetters': '热门信件',
  'feed.courierStats': '信使动态',
  'feed.courierStats.active': '活跃信使',
  'feed.courierStats.delivered': '今日投递',
  'feed.courierStats.join': '加入信使',
  'feed.tags': '热门标签',
  'feed.tab.recommended': '推荐',
  'feed.tab.latest': '最新',
  'feed.tab.following': '关注',
  'feed.empty': '还没有信件，写下第一封吧！',
  'feed.following.empty': '还没有关注任何人，去发现页认识新朋友吧',
  'feed.following.cta': '去发现页',
  'feed.anonymous': '匿名',
  'feed.readMore': '阅读全文',

  // ---- Write ----
  'write.type.label': '信件类型',
  'write.type.normal': '普通信件',
  'write.type.normal.desc': '寄给特定的人',
  'write.type.drift': '漂流信件',
  'write.type.drift.desc': '随机漂流给陌生人',
  'write.type.future': '未来信件',
  'write.type.future.desc': '寄给未来的自己',
  'write.style.label': '信纸样式',
  'write.style.classic': '经典',
  'write.style.classic.desc': '暖色横线纸',
  'write.style.modern': '现代',
  'write.style.modern.desc': '简洁留白',
  'write.style.vintage': '复古',
  'write.style.vintage.desc': '做旧羊皮纸',
  'write.style.elegant': '典雅',
  'write.style.elegant.desc': '精致正式',
  'write.title.placeholder': '信件标题...',
  'write.content.placeholder': '亲爱的朋友，我想给你写封信...',
  'write.recipient.label': '收件人 OP Code',
  'write.recipient.placeholder': '输入 6 位 OP Code（如 PK5F3D）',
  'write.recipient.hint': '留空则信件不会定向投递',
  'write.btn.draft': '存为草稿',
  'write.btn.send': '发送信件',
  'write.success.title': '信件已发送！',
  'write.success.desc': '你的信件已在路上，信使会尽快收取并投递。',
  'write.success.view': '查看信箱',
  'write.success.another': '再写一封',
  'write.anonymous.label': '匿名发送',
  'write.anonymous.hint': '收件人和公开页面不会显示你的姓名',
  'write.anonymous.sender': '匿名作者',

  // ---- Letters ----
  'letters.search.placeholder': '搜索信件...',
  'letters.tab.inbox': '收件箱',
  'letters.tab.sent': '已发送',
  'letters.tab.drafts': '草稿',
  'letters.tab.starred': '已收藏',
  'letters.tab.archived': '已归档',
  'letters.empty.inbox': '还没有收到信件。',
  'letters.empty.inbox.desc': '当有人给你写信时，信件会出现在这里。',
  'letters.empty.sent': '还没有发送过信件。',
  'letters.empty.sent.desc': '今天就开始写你的第一封信吧。',
  'letters.empty.drafts': '没有草稿。',
  'letters.empty.drafts.desc': '今天就开始写你的第一封信吧。',
  'letters.empty.starred': '收藏你喜欢的信件，它们会出现在这里。',
  'letters.empty.archived': '归档的信件会出现在这里。',
  'letters.untitled': '无标题信件',
  'letters.writeNew': '写一封信',
  'letters.status.draft': '草稿',
  'letters.status.generated': '已生成',
  'letters.status.collected': '已取件',
  'letters.status.in_transit': '配送中',
  'letters.status.delivered': '已送达',
  'letters.status.read': '已读',
  'letters.status.approved': '已审核',
  'letters.status.rejected': '已拒绝',
  'letters.status.flagged': '已标记',
  'letters.status.archived': '已归档',
  'letters.statusTracker': '状态追踪',

  // ---- Courier ----
  'courier.apply.title': '成为信使',
  'courier.apply.desc': '加入 OpenPenPal 信使网络，在校园内投递手写信件，赚取积分、徽章，解锁更高等级。',
  'courier.apply.btn': '立即申请',
  'courier.levels.title': '信使等级',
  'courier.level.1': '楼栋投递员',
  'courier.level.1.desc': '负责楼栋内投递',
  'courier.level.2': '片区管理员',
  'courier.level.2.desc': '覆盖整个片区',
  'courier.level.3': '学校协调员',
  'courier.level.3.desc': '服务整个校园',
  'courier.level.4': '城市总监',
  'courier.level.4.desc': '领导信使网络',
  'courier.why.title': '为什么加入？',
  'courier.why.1': '每次投递都能赚取积分',
  'courier.why.2': '解锁专属信使徽章',
  'courier.why.3': '获得信件优先 OP Code',
  'courier.why.4': '连接校园里的写作者',
  'courier.stats.today': '今日任务',
  'courier.stats.completed': '已完成',
  'courier.stats.pending': '待处理',
  'courier.stats.points': '积分',
  'courier.actions.tasks': '我的任务',
  'courier.actions.scan': '扫码',
  'courier.actions.team': '团队',
  'courier.actions.opcode': 'OP 编码',
  'courier.recent': '最近任务',
  'courier.noTasks': '暂无任务。',

  // ---- Discover ----
  'discover.subtitle': '公开信件、展览、收藏合集',
  'discover.tab.plaza': '广场',
  'discover.tab.museum': '博物馆',
  'discover.tab.collections': '收藏',
  'discover.collections.empty': '还没有收藏',
  'discover.collections.emptyDesc': '浏览博物馆，收藏你喜欢的藏品',
  'plaza.untitled': '无标题信件',
  'plaza.empty': '还没有公开信件',
  'museum.anonymous': '匿名',

  // ---- Museum ----
  'museum.title': '信件博物馆',
  'museum.subtitle': '跨越时空的故事、记忆与文字合集',
  'museum.stats.letters': '信件',
  'museum.stats.exhibitions': '展览',
  'museum.stats.contributors': '贡献者',
  'museum.exhibitions': '当前展览',
  'museum.exhibitions.viewAll': '查看全部',
  'museum.filter.all': '全部',
  'museum.filter.future': '未来',
  'museum.filter.memory': '回忆',
  'museum.filter.warmth': '温暖',
  'museum.filter.story': '故事',
  'museum.filter.friendship': '友谊',
  'museum.sort.newest': '最新',
  'museum.sort.views': '最多浏览',
  'museum.sort.likes': '最多喜欢',
  'museum.empty': '暂无藏品。把你的信件投稿到博物馆吧！',
  'museum.prev': '上一页',
  'museum.next': '下一页',

  // ---- Plaza ----
  'plaza.title': '写作广场',
  'plaza.subtitle': '来自身边写作者的公开信件',
  'plaza.stats.letters': '公开信件',
  'plaza.stats.writers': '写作者',
  'plaza.stats.hearts': '收到的心',
  'plaza.comingSoon.title': '完整广场即将上线',
  'plaza.comingSoon.desc': '写作广场将让你发现公开信件、关注喜欢的写作者、与社区分享你的文字。下方为示例预览。',
  'plaza.comingSoon.btn': '获取通知',
  'plaza.filter.all': '全部',
  'plaza.filter.trending': '热门',
  'plaza.filter.recent': '最新',
  'plaza.filter.heartfelt': '走心',
  'plaza.filter.future': '未来信件',
  'plaza.loadMore': '加载更多信件',

  // ---- Profile ----
  'profile.edit': '编辑',
  'profile.opcode': 'OP Code',
  'profile.stats.sent': '已发送',
  'profile.stats.received': '已收到',
  'profile.stats.museum': '博物馆',
  'profile.stats.deliveries': '投递',
  'profile.stats.points': '积分',
  'profile.streak.title': '写作连续',
  'profile.streak.desc': '坚持写作，增长你的连续天数',
  'profile.streak.days': '天',
  'profile.achievements': '成就',
  'profile.achievements.all': '全部徽章',
  'profile.settings': '设置',
  'profile.settings.desc': '账号、隐私、通知',
  'profile.letters.empty.title': '写下你的第一封信',
  'profile.letters.empty.desc': '每一封信都是一次旅程。写给陌生人，写给未来的自己，或者随漂流而去。',
  'profile.letters.empty.btn': '开始写信',
  'profile.letters.guide.normal': '普通信件',
  'profile.letters.guide.normal.desc': '发送给指定的笔友，通过 OP Code 投递',
  'profile.letters.guide.drift': '漂流信件',
  'profile.letters.guide.drift.desc': '放入信箱，等待缘分降临的陌生人',
  'profile.letters.guide.future': '未来信件',
  'profile.letters.guide.future.desc': '写给未来的自己，设定时间后自动送达',
  'profile.letters.recent': '最近活动',

  // ---- Courier Form ----
  'courier.form.title': '基本信息',
  'courier.form.name': '姓名',
  'courier.form.name.placeholder': '你的真实姓名',
  'courier.form.location': '所在地区',
  'courier.form.school': '学校',
  'courier.form.school.placeholder': '请选择学校',
  'courier.form.zone': '投递区域',
  'courier.form.zone.placeholder': '请选择投递区域（可选）',
  'courier.form.transport': '配送方式',
  'courier.form.transport.walk': '步行',
  'courier.form.transport.bike': '自行车',
  'courier.form.transport.ebike': '电动车',
  'courier.form.hours': '每周可用时间（小时）',
  'courier.form.hours.placeholder': '如：10',
  'courier.form.intro': '自我介绍',
  'courier.form.intro.placeholder': '简单介绍你自己，为什么想成为信使？',
  'courier.form.submitting': '提交中...',
  'courier.form.submit': '提交申请',
  'courier.form.submitted': '申请已提交，等待审核',

  // ---- Courier Tasks ----
  'courier.task.pending': '待取件',
  'courier.task.collected': '已取件',
  'courier.task.in_transit': '配送中',
  'courier.task.delivered': '已送达',
  'courier.task.failed': '失败',
  'courier.task.cancelled': '已取消',
  'courier.task.action.collect': '取件',
  'courier.task.action.depart': '出发',
  'courier.task.action.deliver': '送达',

  // ---- Courier Upgrade ----
  'courier.upgrade.title': '申请升级至 L{level}',
  'courier.upgrade.submitted': '升级申请已提交，等待审核',
  'courier.upgrade.submitting': '提交中...',
  'courier.upgrade.btn': '申请升级',

  // ---- Achievements ----
  'achievements.progress': '成就进度',
  'achievements.unlocked': '已解锁 {earned} / {total} 个成就',
  'achievements.badge.firstLetter': '第一封信',
  'achievements.badge.firstLetter.desc': '发出第一封信',
  'achievements.badge.collector': '收信人',
  'achievements.badge.collector.desc': '收到10封信',
  'achievements.badge.courier': '信使',
  'achievements.badge.courier.desc': '完成第一次投递',
  'achievements.badge.starWriter': '明星写手',
  'achievements.badge.starWriter.desc': '获得50个点赞',
  'achievements.badge.dreamer': '追梦人',
  'achievements.badge.dreamer.desc': '写下未来信件',
  'achievements.badge.explorer': '探索者',
  'achievements.badge.explorer.desc': '结交5位笔友',
  'achievements.badge.archivist': '收藏家',
  'achievements.badge.archivist.desc': '博物馆贡献3件',
  'achievements.badge.legend': '传奇',
  'achievements.badge.legend.desc': '积分达到1000',

  // ---- Settings ----
  'settings.title': '设置',
  'settings.tab.profile': '个人资料',
  'settings.tab.privacy': '隐私',
  'settings.tab.notifications': '通知',
  'settings.tab.security': '安全',
  'settings.profile.name': '显示名称',
  'settings.profile.email': '邮箱地址',
  'settings.platform.title': '切换到 Litopia',
  'settings.platform.desc': '你的账号在两个平台通用',
  'settings.platform.btn': '前往 Litopia',
  'settings.signout': '退出登录',
  'settings.privacy.letterVisibility': '信件可见性',
  'settings.privacy.letterVisibility.desc': '谁可以看到你的公开信件',
  'settings.privacy.profileVisibility': '个人资料可见性',
  'settings.privacy.profileVisibility.desc': '谁可以查看你的资料',
  'settings.privacy.opcode': 'OP Code 隐私',
  'settings.privacy.opcode.desc': '是否向他人展示你的 OP Code',
  'settings.privacy.everyone': '所有人',
  'settings.notifications.newLetter': '收到新信件',
  'settings.notifications.newLetter.desc': '有人给你写信时通知',
  'settings.notifications.delivery': '投递更新',
  'settings.notifications.delivery.desc': '信件状态变化时通知',
  'settings.notifications.museum': '博物馆动态',
  'settings.notifications.museum.desc': '你的投稿被收录时通知',
  'settings.notifications.system': '系统通知',
  'settings.notifications.system.desc': '平台公告和更新',
  'settings.security.password': '修改密码',
  'settings.security.password.desc': '上次修改：从未',
  'settings.security.sessions': '登录设备',
  'settings.security.sessions.desc': '管理已登录的设备',
  'settings.security.delete': '删除账号',
  'settings.security.delete.desc': '永久删除你的账号和所有数据',

  // ---- Login ----
  'login.title': 'OpenPenPal',
  'login.subtitle': '文字旅行，心灵相连',
  'login.welcome': '欢迎回来',
  'login.create': '创建账号',
  'login.email': '邮箱',
  'login.email.placeholder': 'you@example.com',
  'login.password': '密码',
  'login.password.placeholder': '••••••••',
  'login.btn.signin': '登录',
  'login.btn.signup': '注册',
  'login.toggle.hasAccount': '已有账号？',
  'login.toggle.noAccount': '没有账号？',
  'login.toggle.signin': '去登录',
  'login.toggle.signup': '去注册',
  'login.litopia': '一个账号，两个平台',

  // ---- AI ----
  'nav.ai': 'AI笔友',
  'ai.tab.inspiration': '云锦传驿',
  'ai.tab.reply': '云中锦书',
  'ai.tab.advice': '角色驿站',
  'ai.tab.match': '笔友匹配',
  'ai.inspiration.title': 'AI写作灵感',
  'ai.inspiration.daily': '今日灵感',
  'ai.inspiration.refresh': '换一批',
  'ai.inspiration.get': '获取灵感',
  'ai.inspiration.empty': '点击「获取灵感」，让AI为你提供写作建议',
  'ai.inspiration.tips': '写作小贴士',
  'ai.inspiration.select': '使用此灵感',
  'ai.reply.title': '选择AI回信风格',
  'ai.reply.desc': '选择一个AI人设，生成符合该风格的回信',
  'ai.reply.generate': '生成AI回信',
  'ai.reply.generating': '生成中...',
  'ai.reply.generated': 'AI生成的回信',
  'ai.reply.preview': '预览',
  'ai.reply.edit': '编辑',
  'ai.reply.use': '使用此回信',
  'ai.reply.copy': '复制',
  'ai.reply.regenerate': '重新生成',
  'ai.reply.disclaimer': 'AI生成的回信仅供参考，建议根据实际情况修改，保持真实和个人风格',
  'ai.reply.noLetter': '请先选择或创建一封信件',
  'ai.advice.title': 'AI回信角度建议',
  'ai.advice.desc': '让AI以特定身份为你提供回信角度建议，而不是直接生成回信内容',
  'ai.advice.personaType': '选择人设类型',
  'ai.advice.personaTypePlaceholder': '请选择一个有意义的身份...',
  'ai.advice.personaName': '人设姓名/称呼 *',
  'ai.advice.personaNamePlaceholder': '例如：奶奶、小明、李雷...',
  'ai.advice.relationship': '关系描述',
  'ai.advice.personaDesc': '人设详细描述（可选）',
  'ai.advice.personaDescPlaceholder': '描述这个人的性格特点、生活经历、说话风格等...',
  'ai.advice.deliveryDays': '延迟获取天数',
  'ai.advice.immediate': '立即获取',
  'ai.advice.generate': '获取回信角度建议',
  'ai.advice.generating': 'AI正在思考中...',
  'ai.advice.perspectives': '角度观点',
  'ai.advice.tone': '情感基调',
  'ai.advice.topics': '话题方向',
  'ai.advice.style': '写作要点',
  'ai.advice.useAdvice': '使用此建议开始写信',
  'ai.advice.reset': '重新选择人设',
  'ai.advice.familyLabel': '亲人',
  'ai.advice.friendLabel': '朋友',
  'ai.advice.romanticLabel': 'TA',
  'ai.advice.customLabel': '自定义人设',
  'ai.match.title': 'AI笔友匹配',
  'ai.match.desc': '根据你的信件内容，AI为你推荐志趣相投的笔友',
  'ai.match.find': '开始匹配',
  'ai.match.matching': '匹配中...',
  'ai.match.score': '匹配度',
  'ai.match.connect': '写信给Ta',
  'ai.match.empty': '暂无匹配结果，随着平台成长将匹配到更多笔友',
  'ai.match.demo': '当前为演示数据，真实匹配需要更多用户',
  'ai.stats.title': 'AI使用统计',
  'ai.stats.today': '今日使用',
  'ai.stats.remaining': '剩余次数',

  // ---- Drift ----
  'drift.title.bottle': '漂流瓶',
  'drift.title.letter': '漂流信',
  'drift.subtitle.bottle': '投出一个瓶子，等待一段缘分',
  'drift.subtitle.letter': '写一封长信，寄给未知的远方',
  'drift.throw': '投出',
  'drift.pick': '捡起',
  'drift.read': '读信',
  'drift.compose': '写漂流',
  'drift.conversation': '漂流对话',
  'drift.empty.bottle': '海面平静，没有漂流瓶',
  'drift.empty.letter': '信箱空空，没有漂流信',
  'drift.limit.reached': '今日次数已用完',
  'drift.anonymous': '匿名',
  'drift.startConversation': '开始对话',
  'drift.endConversation': '结束对话',
  'drift.ended': '对话已结束',
  'drift.fromAfar': '来自远方',
  'drift.tryAgain': '再试一次',
  'drift.retry': '重试',
  'drift.fetchFailed': '获取失败',
  'drift.comeBackLater': '稍后再来看看吧',
  'drift.pickAgain': '再捡一个',
  'drift.readAgain': '再读一封',
  'drift.pickBottle': '捡瓶子',
  'drift.pickCta.bottle': '来捡一个漂流瓶吧',
  'drift.pickCta.letter': '来读一封漂流信吧',
  'drift.connecting': '正在连接...',
  'drift.throw.bottle': '扔一个',
  'drift.throw.letter': '投信',
  'drift.pick.bottle': '捡一个',
  'drift.read.letter': '读信',
  'drift.active.count': '%s 个',
  'drift.reply.count': '%s 条回复',
  'drift.history': '我的漂流',
  'drift.badge.bottle': '瓶',
  'drift.badge.letter': '信',
  'drift.active.title': '进行中的对话',
  'drift.compose.thrown.bottle': '瓶子已投入大海',
  'drift.compose.thrown.letter': '信已寄出远方',
  'drift.compose.title.bottle': '投瓶',
  'drift.compose.title.letter': '投信',
  'drift.compose.limitReached': '今日投递次数已用完，明天再来吧',
  'drift.compose.style': '纸张风格',
  'drift.compose.titlePlaceholder': '给信取个标题（可选）',
  'drift.compose.bottlePlaceholder': '写下你想说的话（10-500字）...',
  'drift.compose.letterPlaceholder': '写下你的心事（50-50000字）...',
  'drift.compose.moodLabel': '心情标签（最多3个）',
  'drift.compose.anonymous': '匿名投递',
  'drift.compose.sending': '发送中...',
  'drift.compose.send.bottle': '投出瓶子',
  'drift.compose.send.letter': '寄出信件',
  'drift.compose.limitError': '今日发送次数已达上限',
  'drift.compose.sendFailed': '发送失败，请稍后重试',
  'drift.style.classic': '经典',
  'drift.style.classic.desc': '温暖纸张',
  'drift.style.modern': '现代',
  'drift.style.modern.desc': '简洁白',
  'drift.style.vintage': '复古',
  'drift.style.vintage.desc': '泛黄',
  'drift.style.elegant': '雅致',
  'drift.style.elegant.desc': '素雅',
  'drift.mood.happy': '开心',
  'drift.mood.sad': '忧伤',
  'drift.mood.lonely': '孤独',
  'drift.mood.grateful': '感恩',
  'drift.mood.curious': '好奇',
  'drift.mood.anxious': '焦虑',
  'drift.mood.hopeful': '期盼',
  'drift.mood.nostalgic': '怀念',
  'drift.mood.peaceful': '平静',
  'drift.mood.excited': '兴奋',

  // ---- Notifications ----
  'notifications.title': '通知',
  'notifications.empty': '暂无通知',
  'notifications.empty.desc': '新通知会在这里显示',
  'notifications.default': '新通知',
  'notifications.filter.all': '全部',
  'notifications.filter.letters': '信件',
  'notifications.filter.courier': '投递',
  'notifications.filter.system': '系统',

  // ---- Discover Drift Tab ----
  'discover.drift.title': '漂流瓶 & 漂流信',
  'discover.drift.desc': '投出一个瓶子或一封信，与未知的人建立联系',
  'discover.drift.enter': '进入漂流',
  'discover.tab.drift': '漂流',

  // ---- Museum Exhibitions ----
  'museum.exhibition.featured': '精选',
  'museum.exhibition.views': '次浏览',
  'museum.exhibition.content': '展览内容',
  'museum.exhibition.empty': '该展览暂无内容',

  // ---- Comments ----
  'comment.title': '评论',
  'comment.empty': '暂无评论',
  'comment.placeholder': '写下你的评论…',
  'comment.loginRequired': '登录后参与评论',
  'comment.anonymous': '匿名',

  // ---- Museum Collection ----
  'museum.collection.add': '添加收藏',
  'museum.collection.remove': '取消收藏',

  // ---- 404 ----
  'notFound.title': '页面不存在',
  'notFound.description': '你要找的页面已经消失，就像一封没有地址的信。',
  'notFound.back': '返回首页',

  // ---- Write page ----
  'write.draft.saved': '草稿已保存',
  'write.draft.saveFailed': '保存失败，请稍后重试',
  'write.schedule.dateRequired': '请选择定时投递日期',
  'write.opcode.notFound': '验证服务未找到',
  'write.opcode.serverError': '服务器错误',
  'write.opcode.networkError': '网络错误',
  'write.opcode.validationFailed': 'OP Code 验证失败: %s，您可以稍后重试或留空收件人',
  'write.opcode.invalid': 'OP Code 不存在或格式错误，请检查后重试',
  'write.opcode.unreachable': '无法连接验证服务，您可以留空收件人或稍后重试',
  'write.send.failed': '发送失败，请稍后重试',
  'write.draft.autoSaved': '草稿已自动保存',
  'write.nav.drafts': '草稿箱',
  'write.reply.cancel': '取消',
  'write.reply.label': '正在回复信件',
  'write.field.title': '信件标题',
  'write.field.content': '信件内容',
  'write.options.more': '更多选项',
  'write.options.configured': '已配置',
  'write.template.show': '使用模板',
  'write.template.hide': '隐藏模板',
  'write.template.empty': '暂无可用模板',
  'write.envelope.show': '选择信封',
  'write.envelope.hide': '收起信封',
  'write.envelope.selected': '已选',
  'write.envelope.default': '信封设计',
  'write.envelope.typeCity': '城市',
  'write.envelope.typeCampus': '校园',
  'write.envelope.empty': '暂无可用信封设计',
  'write.visibility.label': '可见范围',
  'write.visibility.private': '私密',
  'write.visibility.public': '公开',
  'write.schedule.label': '定时投递',
  'write.schedule.hint': '选择信件将在未来某天送达的日期（最短明天）',
  'write.send.errorRetry': '发送失败，请稍后重试。',
  'write.draft.viewAll': '全部',
  'write.draft.empty': '暂无草稿',
  'write.draft.untitled': '无标题草稿',

  // ---- DriftConversation page ----
  'drift.conversation.titleBottle': '漂流瓶对话',
  'drift.conversation.titleLetter': '漂流信对话',
  'drift.conversation.end': '结束对话',
  'drift.conversation.anonymous': '匿名',
  'drift.conversation.originalAuthor': '原作者',
  'drift.conversation.originalContent': '原始内容',
  'drift.conversation.ended': '对话已结束',
  'drift.conversation.replyProgress': '回复进度：%s/%s',
  'drift.conversation.replyExhausted': '你的回复次数已用完',
  'drift.conversation.replyPlaceholder': '写下你的回复...',

  // ---- Letters page ----
  'letters.action.saveFailed': '收藏操作失败，请重试',
  'letters.share.copied': '链接已复制',
  'letters.share.copyFailed': '复制失败，请手动复制链接',
  'letters.error.loadFailed': '加载失败',
  'letters.error.networkError': '网络连接出现问题，请重试',
  'letters.error.retry': '重新加载',
  'letters.count': '共 %s 封信件',
  'letters.unread': '%s 封未读',
  'letters.action.reply': '回复',
  'letters.action.share': '分享',
  'letters.drift.title': '漂流对话',
  'letters.drift.desc': '查看我的漂流瓶和漂流信对话',
  'letters.photo.loadFailed': '加载失败',
  'letters.photo.uploadFailed': '上传失败，请重试',
  'letters.share.count': '已被分享 %s 次',
  'letters.thread.count': '对话链 · %s 封回复',
  'letters.thread.lastReply': '最近回复',
  'letters.photo.title': '附件照片',
  'letters.photo.uploading': '上传中...',
  'letters.photo.upload': '上传照片',

  // ---- Admin ----
  'admin.console': '管理控制台',
  'admin.nav.dashboard': '总览',
  'admin.nav.users': '用户管理',
  'admin.nav.letters': '信件管理',
  'admin.nav.review': '内容审核',
  'admin.nav.couriers': '信使管理',
  'admin.nav.envelopes': '信封管理',
  'admin.nav.reports': '举报处理',
  'admin.nav.aiConfig': 'AI 配置',
  'admin.nav.settings': '系统设置',
  'admin.page.dashboard.title': '总览',
  'admin.page.dashboard.sub': '欢迎回来，查看平台最新数据',
  'admin.page.users.title': '用户管理',
  'admin.page.users.sub': '管理所有 OPP 注册用户',
  'admin.page.letters.title': '信件管理',
  'admin.page.letters.sub': '查看和管理所有信件',
  'admin.page.review.title': '内容审核',
  'admin.page.review.sub': '管理被举报的信件内容',
  'admin.page.couriers.title': '信使管理',
  'admin.page.couriers.sub': '管理信使团队',
  'admin.page.envelopes.title': '信封管理',
  'admin.page.envelopes.sub': '审核和管理信封设计',
  'admin.page.reports.title': '举报处理',
  'admin.page.reports.sub': '处理用户举报',
  'admin.page.aiConfig.title': 'AI 配置',
  'admin.page.aiConfig.sub': '管理 AI 供应商和 API 密钥',
  'admin.page.settings.title': '系统设置',
  'admin.page.settings.sub': 'OpenPenPal 平台配置',
  'admin.page.default.title': '管理后台',
  'admin.user.admin': '管理员',
  'admin.user.superAdmin': '超级管理员',
};

export function getCopy(key: string): string {
  return productCopy[key] ?? key;
}

export function useCopy(): { t: (key: string) => string } {
  return { t: getCopy };
}
